import React from "react";
import Layout from "../../layouts/Layout";
import IconRegister from "../../components/icons/icon-register";

import Box from "@mui/material/Box";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
// import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import TextFieldSC from "../../components/TextFieldSC";
import DesktopDatePickerSC from "../../components/DesktopDatePickerSC";
import SelectSC from "../../components/SelectSC";
import IconButton from "@mui/material/IconButton";
// import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Dropzone from "../../components/Dropzone";
import FileUpload from "../../components/icons/FileUpload";
import CheckIcon from "@mui/icons-material/Check";
import Notification from "../../services/notification.service";
import apiService from '../../utils/api.service';
import { useNavigate } from "react-router-dom";
import BButton from "../../components/general/BButton";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import moment from "moment";
import helper from "../../utils/helper";
import ExitPopup from "../../components/icons/ExitPopup"
import TextMaskIdCard from "../../components/general/TextMaskIdCard"
import TextMaskLicenseNo from "../../components/general/TextMaskLicenseNo"
import TextMaskBank from "../../components/general/TextMaskBank"
import SpaceBar from "../../components/general/SpaceBar"
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/th';

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newOpen: true,
      open: false,
      openType: "",
      isSubmit: false,
      error: {},
      errLen10: false,
      errLen13: false,
      resumeFile: null,
      data: {
        firstname: "",
        lastname: "",
        idCard: "",
        birthday: null,
        phone: "",
        email: "",
        address: "",
        licenseNumber: "",
        position: "",
        educationalQualification: "",
        recommenderCode: "",
        bank: "",
        bankAccountNumber: "",
        isCheck: false,
      },
      reasonsList: [
        { value: "1", text: "xxxxxxxxxx 1" },
        { value: "2", text: "xxxxxxxxxx 2" },
        { value: "3", text: "xxxxxxxxxx 3" },
      ],
      resumeErr: false,
      loading: false
    };
  }

  changeValue(e, type, targetValue = "target") {
    console.log(e, type, targetValue);
    let value = null;
    if (targetValue === "target") {
      value = e.target.value;
    } else if (targetValue === "checked") {
      value = e.target.checked;
    } else {
      value = e;
    }

    let { data } = this.state;
    const nextState = data;
    nextState[type] = value;
    this.checkValidation(nextState);
    console.log("nextState", nextState);
    this.setState({ data: nextState });
  }

  checkValidation(data) {
    // console.log("this.state.isSubmit",this.state.isSubmit);
    if (!this.state.isSubmit) {
      return false;
    }
    let error = this.state.error;
    let required = [
      "firstname",
      "lastname",
      "idCard",
      // "birthday",
      "phone",
      "email",
      "address",
      "licenseNumber",
      "position",
      // "educationalQualification",
      // "recommenderCode",
      "bank",
      "bankAccountNumber",
      "isCheck",
    ];
    let hasError = false;
    for (var i in data) {
      if (!data[i] && required.indexOf(i) > -1) {
        error[i] = true;
        hasError = true;
      } else {
        error[i] = false;
      }
    }

    this.setState({ error: error });
    return hasError;
  }

  async onSave() {
    let hasError = this.checkValidation(this.state.data);
    console.log("this.state.data", this.state.data);
    // const headertest = helper.GEN.header()
    const { data, resumeFile } = this.state
    const { errLen10, errLen13 } = this.state
    console.log("hasError", hasError)
    console.log("errLen10", errLen10)
    console.log("errLen13", errLen13)
    console.log("resumeFile", resumeFile)
    if (!hasError && !errLen10 &&!errLen13 && resumeFile) {
      console.log("Pass", this.state.data);
      // const resumeFileURL = await this.uploadImage(resumeFile)
      const resumeFileURL = resumeFile
      const payload = {
        lineId: this.props.user.lineId.lineId,
        firstName: data.firstname,
        lastName: data.lastname,
        identificationNo: data.idCard,
        birthDate: moment(data.birthday.$d || data.birthday).format('YYYY-MM-DD'),
        phone: data.phone,
        email: data.email,
        address: data.address,
        licenseNo: data.licenseNumber,
        position: data.position,
        education: data.educationalQualification,
        recommenderCode: data.recommenderCode,
        resumeFile: resumeFileURL,
        reason: helper.FN.toArrayNumber(this.checkboxObjToArray(data, 'reason')),
        bank: data.bank,
        bankAccountNo: data.bankAccountNumber,
        isAgree: 1
      }
      console.log('payload >>', payload)
      this.createProfile(payload)
    } else {
      this.setState({ resumeErr: true })
    }
  }

  checkboxObjToArray(obj,name){
    let temp = {}
    temp[name] = [];
    for(let i in obj) {
      if (i.toString().indexOf(name) > -1) {
        if (obj[i]) {
          temp[name].push(i.toString().replace(name+"[","").replace("]",""))
        }
      }  
    }
    return temp[name]
  }
  
  async createProfile(payload = {}) {
    try {
      this.setState({ loading: true });
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.Profile.CreateRegister(payload, header)
      this.setState({ loading: false });
      if (resData.resultCode === "20000") {

        Notification.success({ 
          title: "Success!", description: "บันทึกสำเร็จ" , 
          onCancel: () => { this.props.navigate(`/authprofile`) } 
        });
      } else {
        Notification.error({ title: "ขออภัย", description: "รหัสผู้แนะนำไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง" });
      }
    }
    catch(e){
      this.setState({ loading: false });
      console.log('API ERR', e)
    }
  }

  async uploadImage(file = '') {
    return  new Promise(async (resolve, reject) => {
      try {
        this.setState({ loading: true });
        const { resData } = await apiService.External.UploadFile({ file: file })
        this.setState({ loading: false });
        resolve(resData.URL)
      }
      catch(e){
        console.log('API uploadImage ERR', e)
      }
    });
  }

  render() {
    let { error, data, resumeErr } = this.state;
    let { isSubmit, errLen10, errLen13 } = this.state;
    const { openType } = this.state;
    const { option } = this.props
    return (
      <Layout>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'th'}>
          <div className="main-header">
            <div className="main-header-text">สมัครสมาชิก</div>
          </div>
          <div className="main-body">
            <IconRegister style={{ margin: "auto", textAlign: "center" }} />
            <div className="row">
              <div className="col-xs-12">
                <Box
                  component="form"
                  sx={{}}
                  noValidate
                  autoComplete="off"
                  className="form-save"
                >
                  <div className="row">
                    <div className="col-xs-12">
                      <div className="main-body-header">ข้อมูลส่วนตัว</div>
                    </div>
                    <div className="col-xs-6 col-div">
                      <TextFieldSC
                        label="ชื่อ"
                        id="firstname"
                        variant="standard"
                        required={true}
                        fullWidth
                        error={error.firstname}
                        value={data.firstname}
                        onChange={(e) => this.changeValue(e, "firstname")}
                      />
                    </div>
                    <div className="col-xs-6 col-div">
                      <TextFieldSC
                        label="นามสกุล"
                        id="lastname"
                        variant="standard"
                        required={true}
                        fullWidth
                        error={error.lastname}
                        value={data.lastname}
                        onChange={(e) => this.changeValue(e, "lastname")}
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      
                      <TextFieldSC
                        label="เลขที่บัตรประชาชน"
                        id="idCard"
                        variant="standard"
                        required={true}
                        fullWidth
                        value={data.idCard}
                        error={error.idCard || (isSubmit && errLen13)}
                        onChange={(e) => {
                          this.changeValue(e, "idCard")
                          this.setState({ errLen13 : helper.CKFORM.cardID(e.target?.value)})
                        }}
                        InputProps={{ inputComponent: TextMaskIdCard }}
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      <DesktopDatePickerSC
                        error={error.birthday}
                        value={data.birthday}
                        required={true}
                        onChange={(e) =>
                          this.changeValue(e, "birthday", "value")
                        }
                        label="วัน เดือน ปีเกิด"
                        inputFormat="DD/MM/YYYY"
                        renderInput={(params) => (
                          <TextFieldSC
                            variant="standard"
                            fullWidth
                            {...params}
                          />
                        )}
                      />
                    </div>

                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.phone}
                        value={data.phone}
                        required={true}
                        onChange={(e) => this.changeValue(e, "phone")}
                        label="เบอร์โทรศัพท์"
                        id="phone"
                        variant="standard"
                        fullWidth
                      />
                    </div>

                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.email}
                        value={data.email}
                        required={true}
                        onChange={(e) => this.changeValue(e, "email")}
                        label="อีเมล"
                        id="email"
                        variant="standard"
                        fullWidth
                      />
                    </div>

                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.address}
                        value={data.address}
                        required={true}
                        onChange={(e) => this.changeValue(e, "address")}
                        label="ที่อยู่"
                        id="address"
                        variant="standard"
                        fullWidth
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.licenseNumber || (isSubmit && data.licenseNumber?.length < 10)}
                        value={data.licenseNumber}
                        required={true}
                        onChange={(e) => this.changeValue(e, "licenseNumber")}
                        label="เลขที่ใบประกอบวิชาชีพ"
                        id="licenseNumber"
                        variant="standard"
                        fullWidth
                        InputProps={{ inputComponent: TextMaskLicenseNo }}
                      />
                    </div>

                    <div className="col-xs-12 col-div">
                      <SelectSC
                        error={error.position}
                        value={data.position}
                        onChange={(e) =>
                          this.changeValue(e, "position")
                        }
                        required={true}
                        labelId="position"
                        id="position"
                        label="ตำแหน่ง"
                        variant="standard"
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem disabled value="">ตำแหน่ง<span className="txt-err">*</span></MenuItem>
                        {
                          option.position.map((item,index) => (
                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                          ))
                        }
                      </SelectSC>
                    </div>

                    <div className="col-xs-12 col-div">
                      <SelectSC
                        error={error.educationalQualification}
                        value={data.educationalQualification}
                        required={true}
                        onChange={(e) =>
                          this.changeValue(e, "educationalQualification")
                        }
                        labelId="educationalQualification"
                        id="educationalQualification"
                        label="วุฒิการศึกษา"
                        variant="standard"
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem disabled value="">วุฒิการศึกษา</MenuItem>
                        {
                          option.education.map((item,index) => (
                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                          ))
                        }
                      </SelectSC>
                    </div>

                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.recommenderCode}
                        value={data.recommenderCode}
                        onChange={(e) => this.changeValue(e, "recommenderCode")}
                        label="รหัสแนะนำ"
                        id="recommenderCode"
                        variant="standard"
                        fullWidth
                      />
                    </div>

                    <div className="col-xs-12">
                      <div className="main-body-header">ข้อมูลการทำงาน</div>
                      <div className="profile-history">ประวัติการทำงาน<span className="txt-err">*</span></div>
                    </div>
                    <div className="col-xs-12 col-div">
                      <Dropzone
                        onDrop={(file) => {
                          console.log("file", file.base64);
                          const RESUMEMAXSIZEFILE = helper.CONFIG.RESUMEMAXSIZEFILE
                          const RESUMETYPEFILE = helper.CONFIG.RESUMETYPEFILE
                          console.log("RESUMEMAXSIZEFILE", RESUMEMAXSIZEFILE);
                          if (RESUMETYPEFILE.includes(file.file[0]?.type) && file.file[0]?.size <= RESUMEMAXSIZEFILE) {
                            this.setState({ resumeErr: false, resumeFile: file.base64, resumeName: file.file[0].name });
                          } else {
                            this.setState({ resumeErr: true, resumeFile: null, resumeName: '' });
                          }
                        }}
                        closeStyle={'resume'}
                        onClose={() => {
                          this.setState({ resumeFile: null, resumeName: '' });
                        }}
                        dropUI={
                          <>
                            <div className={`want-resume ${resumeErr? 'err' : '' }`}>
                              <h5>กรุณาแนบ Resume</h5>
                              <div className="icon"><FileUpload /></div>
                            </div>
                            { 
                              resumeErr &&
                              <div className="err-img">
                                <div>- สามารถอัพโหลดไฟล์ .jpg .jpeg .pdf เท่านั้น</div>
                                <div>- ขนาดไฟล์ไม่เกิน 10 MB</div>
                              </div>
                            }
                          </>
                        }
                        isDropSuccess={this.state.resumeFile}
                        dropSuccessUI={
                          <div className="want-resume active">
                            <h5>Resume</h5>
                            <div className="icon"><FileUpload /></div>
                          </div>
                        }
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      <div className="main-field-header">
                        เหตุผลที่ต้องการใช้งาน Nurse
                      </div>

                      <div className="main-field-subheader">
                        สามารถเลือกได้มากกว่า 1 ข้อ
                      </div>

                      <FormGroup>
                        { option.nurseReason.map((r, i) => {
                          return (
                            <FormControlLabel
                              key={i}
                              control={
                                <Checkbox
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 28 },
                                  }}
                                  value={data[`reason[${r.id}]`]}
                                  onChange={(e) =>
                                    this.changeValue(e, `reason[${r.id}]`, "checked")
                                  }
                                />
                              }
                              label={r.name}
                            />
                          );
                        })}
                      </FormGroup>
                    </div>
                    <div className="col-xs-12">
                      <div className="main-body-header">ข้อมูลบัญชีธนาคาร</div>
                    </div>
                    <div className="col-xs-12 col-div">
                      <SelectSC
                        error={error.bank}
                        value={data.bank}
                        required={true}
                        onChange={(e) => this.changeValue(e, "bank")}
                        labelId="bank"
                        id="bank"
                        label="ธนาคาร"
                        variant="standard"
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem disabled value="">ธนาคาร<span className="txt-err">*</span></MenuItem>
                        {
                          option.bank.map((item,index) => (
                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                          ))
                        }
                      </SelectSC>
                    </div>
                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        value={data.bankAccountNumber}
                        error={error.bankAccountNumber || (isSubmit && errLen10)}
                        required={true}
                        onChange={(e) => {
                          this.changeValue(e, "bankAccountNumber")
                          this.setState({ errLen10 : helper.CKFORM.textLen(e.target?.value, 12)})
                        }}
                        label="เลขที่บัญชีธนาคาร"
                        id="bankAccountNumber"
                        variant="standard"
                        fullWidth
                        InputProps={{ inputComponent: TextMaskBank }}
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      <FormGroup style={{ display: "contents" }}>
                        <FormControlLabel
                          error={error.isCheck}
                          control={
                            <Checkbox
                              className="disable-test"
                              sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                              value={data.isCheck}
                              onChange={(e) => this.changeValue(e, "isCheck")}
                            />
                          }
                          label={<></>}
                        />
                        <label className="label-regis">
                          ฉันยอมรับ{" "}<a onClick={ () => { this.setState({ open: true, openType: "1" })} }>นโยบายความเป็นส่วนตัว</a>
                          ,{" "}<a onClick={ () => { this.setState({ open: true, openType: "2" })} }>ข้อตกลงการทำงาน</a>{" "}
                          และ{" "}<a onClick={ () => { this.setState({ open: true, openType: "3" })} }>รายละเอียดค่าสมาชิก</a>
                        </label>
                      </FormGroup>
                    </div>
                    <div className="col-xs-12 col-div" style={{ paddingTop: 10 }}>
                      <BButton disable={!data.isCheck || this.state.loading} setStyle="block" onClick={ () => { this.setState({ isSubmit: true },
                          () => { this.onSave() });
                        }}
                      >ลงทะเบียน</BButton>
                    </div>
                  </div>
                </Box>
              </div>
            </div>
          </div>
          <Dialog 
            className="dialog-nurse" open={this.state.open}
            onClose={() => { this.setState({ open1: false }) }}
          >
            <DialogTitle>
              <h2>
                { openType == "1" ? <>นโยบายความเป็นส่วนตัว</> : null }
                { openType == "2" ? <>ข้อตกลงการทำงาน</> : null }
                { openType == "3" ? <>รายละเอียดค่าสมาชิก</> : null }
              </h2>
              <div className="icon" onClick={() => this.setState({ open: false })}><ExitPopup/></div>
            </DialogTitle>
            <DialogContent>
              {/* <DialogContentText> */}
             
              { openType == "2" ? <>
              <ul className="description-detail">
                <li> - การบันทึกการเข้า-ออก การทำงาน</li>
                <li>บันทึกการเข้า-ออก การทำงาน เป็นอันดับแรก เมื่อมาถึงที่ปฏิบัติงาน และจะไม่มี การขาด ลา มาสาย</li>
                <li>ท่านสามารถจัดการเกี่ยวกับการวางแผน การทำงานไว้ล่วงหน้า ในการใช้ชีวิตของท่านได้อย่างลงตัว เรามีความยินดีสนับสนุนท่านต่อไป</li>
              </ul>
              </> : null }


              { openType == "3" ? <>
              <ul className="description-detail line-height">
                <li>การสมัครเป็นสมาชิก  การทำงานที่ตรงต่อเวลา ไม่ขาดลามาสาย การเก็บแต้มบุญ</li>
                <li>การสมัครสมาชิก</li>
                <li><SpaceBar/>1. การสมัครสมาชิก รายเดือน 200 บาท</li>
                <li><SpaceBar/>2. รายปี 599 บาท</li>
              </ul>
              <ul className="description-detail line-height">
                <li>ค่าใช้จ่ายที่เกิดขึ้น  เป็นผลประโยชน์ กับท่านทั้งสิ้น</li>
                <li><SpaceBar/>• การโอนเงินตรงเวลาผ่าน บัญชีบริษัท ฯ อัตโนมัติ</li>
                <li><SpaceBar/>• การสร้างความมั่นใจ กับท่าน สมาชิกและผู้ว่าจ้าง</li>
                <li><SpaceBar/>• สมาชิกรายปี สามารถ รับโบนัสประจำปี และสิทธิประโยชน์ อื่นๆมากมาย</li>
                <li><SpaceBar/>• มีความมั่นคง มีงานพร้อมรองรับแน่นอน</li>
                <li><SpaceBar/>• มีความชัดเจน ในรายรับที่จะเกิดขึ้น สามารถวางแผนงาน วางอนาคตได้ชัดเจนมากขึ้น</li>
              </ul>
              </> : null }

              {/* </DialogContentText> */}
            </DialogContent>
          </Dialog>
          {/* 111 */}
          <Dialog className="dialog-nurse" open={this.state.newOpen} onClose={() => { this.setState({ newOpen: false });}}>
            <DialogTitle>
              <h2>คำแนะนำก่อนสมัครสมาชิก TNT</h2>
              <div className="icon" onClick={() => this.setState({ newOpen: false })}><ExitPopup/></div>
            </DialogTitle>
            <DialogContent>
            <ul className="description-detail ">
              <li>
                <SpaceBar/>ขอให้การปฏิบัติงานพยาบาล ร่วมกับ TNT ของท่าน สมาชิก จงเป็นประโยชน์สูงสุดแก่ท่าน   จึงขอแจ้งกฎ และระเบียบร่วมกัน เป็นไปในแนวทางเดียวกัน  ด้วยความปรารถนาดีต่อความสำเร็จของท่านสมาชิก โปรดทำความเข้าใจตลอดการสมัครสมาชิก TNT
              </li>
              <li>
                <SpaceBar/>Team Nurse ( Thailand ) หรือ TNT เป็นนิติบุคคล ถูกต้องตามกฎหมาย  จัดตั้งขึ้นเมื่อ ปี 2557 จนถึง ปัจจุบัน  เพื่อให้เข้าถึงธรรมชาติ ของพยาบาล ความต้องการของพยาบาล ความสุขในการทำงานของพยาบาล โดยผ่านระบบออนไลน์
              </li>
              <li>
                TNT เป็นองค์กร ที่เป็นศิลปะในการดำเนินชีวิต ที่ทำงานร่วมกับองค์กรณ์อื่น อย่างสมดุลและมีความสุข
              </li>
              <li>
                TNT เป็นองค์กร ที่เป็นทางเลือกของพยาบาล เราสามารถเผชิญความเครียด ปัญหาต่างๆในชีวิต  ที่เกิดจากความคาดหวังในงานเป็นไปด้วยความสงบและสมดุล  มีความสุขสนุกกับการทำงานได้ในทุกๆวัน
              </li>
              <li>
                <SpaceBar/>เมื่อท่านพร้อม ที่จะเดินไปกับเรา  กฎระเบียบต่างๆที่กำหนดขึ้น มิได้เพียงประโยชน์ แก่การบริหาร เท่านั้น แต่ประโยชน์สูงสุดต่อเนื่อง และยั่งยืน  มาจากประสบการณ์ ของท่าน สมาชิก TNT โดยตรง ที่ปฏิบัติตามและรักษากฎระเบียบได้อย่างเหมาะสม การฝ่าฝืนกฎระเบียบ จะทำให้เกิดมลภาวะ วุ่นวาย มากมาย ต่อทุกอย่างที่เกี่ยวเนื่อง  ดังนั้นสมาชิก TNT จะต้องศึกษาใคร่ครวญและปฏิบัติกฎระเบียบต่างๆ อย่างเคร่งครัด  ผู้ที่คิดว่าสามารถปฏิบัติตามกฎเกณฑ์ได้เท่านั้นจึงควรสมัครเป็นสมาชิก TNT เพราะจะเสียเวลาโดยเปล่าประโยชน์ และจะเป็นการขัดขวางหรือรบกวนคนอื่นที่ตั้งใจเข้ามาสมัครเป็นสมาชิกด้วยความตั้งอกตั้งใจอีกด้วย
              </li>
            </ul>
            {/* 
                ขอให้การปฏิบัติงานพยาบาล ร่วมกับ TNT ของท่าน สมาชิก จงเป็นประโยชน์สูงสุดแก่ท่าน   จึงขอแจ้งกฎ และระเบียบร่วมกัน เป็นไปในแนวทางเดียวกัน  ด้วยความปรารถนาดีต่อความสำเร็จของท่านสมาชิก โปรดทำความเข้าใจตลอดการสมัครสมาชิกTNT
                Team Nurse ( Thailand ) หรือ TNT เป็นนิติบุคคล ถูกต้องตามกฎหมาย  จัดตั้งขึ้นเมื่อ ปี 2557 จนถึง ปัจจุบัน  เพื่อให้เข้าถึงธรรมชาติ ของพยาบาล ความต้องการของพยาบาล ความสุขในการทำงานของพยาบาล โดยผ่านระบบออนไลน์
                TNT เป็นองค์กร ที่เป็นศิลปะในการดำเนินชีวิต ที่ทำงานร่วมกับองค์กรณ์อื่น อย่างสมดุลและมีความสุข
                TNT เป็นองค์กร ที่เป็นทางเลือกของพยาบาล เราสามารถเผชิญความเครียด ปัญหาต่างๆในชีวิต  ที่เกิดจากความคาดหวังในงานเป็นไปด้วยความสงบและสมดุล  มีความสุขสนุกกับการทำงานได้ในทุกๆวัน
                เมื่อท่านพร้อม ที่จะเดินไปกับเรา  กฎระเบียบต่างๆที่กำหนดขึ้น มิได้เพียงประโยชน์ แก่การบริหาร เท่านั้น แต่ประโยชน์สูงสุดต่อเนื่อง และยั่งยืน  มาจากประสบการณ์ ของท่าน สมาชิก TNT โดยตรง ที่ปฏิบัติตามและรักษากฎระเบียบได้อย่างเหมาะสม การฝ่าฝืนกฎระเบียบ จะทำให้เกิดมลภาวะ วุ่นวาย มากมาย ต่อทุกอย่างที่เกี่ยวเนื่อง  ดังนั้นสมาชิก TNT จะต้องศึกษาใคร่ครวญและปฏิบัติกฎระเบียบต่างๆ อย่างเคร่งครัด  ผู้ที่คิดว่าสามารถปฏิบัติตามกฎเกณฑ์ได้เท่านั้นจึงควรสมัครเป็นสมาชิก TNT เพราะจะเสียเวลาโดยเปล่าประโยชน์ และจะเป็นการขัดขวางหรือรบกวนคนอื่นที่ตั้งใจเข้ามาสมัครเป็นสมาชิกด้วยความตั้งอกตั้งใจอีกด้วย
            */}
            </DialogContent>
          </Dialog>
        </LocalizationProvider>
      </Layout>
    );
  }
}

function RegisterRoute(props) {
  let navigate = useNavigate();
  return <Register navigate={navigate} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(RegisterRoute);
